import { IUser } from '../../../assets/types/dtoTypes';
import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SasTokenService } from './sas-token.service';
import { environment } from '../../environments/environment';

@Injectable( {
  providedIn: 'root',
} )
export class ImageService {
  private sasTokenService: SasTokenService;


  constructor() {
    const sasTokenService = inject(SasTokenService);

    this.sasTokenService = sasTokenService;
  }

  appendSasTokenToProfileImage( profile: Partial<IUser> ): Observable<Partial<IUser>> {
    if ( profile.profileImageUrl && profile.profileImageUrl.includes( 'googleusercontent' ) ) {
      return of( profile );
    } else if ( profile.profileImageUrl && !profile.profileImageUrl.includes( '?sv=' ) ) {
      return this.sasTokenService.getSasToken( profile.id, this.extractFileName( profile.profileImageUrl ) ).pipe(
        map( sasToken => {
          profile.profileImageUrl += `?${sasToken}`;
          return profile;
        } ),
        catchError( error => {
          console.error( `Failed to get SAS token for user ${profile.id}`, error );
          return of( profile );
        } ),
      );
    } else {
      return of( profile );
    }
  }

  appendSasTokenToCompanyImage( url: string, companyId: string, forceRefresh = false ): Observable<string> {
    if ( !url ) return of( '' );

    const hasSas = url.includes( '?sv=' );
    if ( hasSas && !forceRefresh ) return of( url );

    const fileName = this.extractFileName( url.split( '?' )[0] );
    const canonicalBaseUrl = this.buildCompanyBlobUrl( companyId, fileName );

    return this.sasTokenService.getSasTokenForCompany( companyId, fileName ).pipe(
      map( sasToken => `${canonicalBaseUrl}?${sasToken}` ),
      catchError( error => {
        console.error( `Failed to get SAS token for company ${companyId}`, error );
        return of( canonicalBaseUrl );
      } ),
    );
  }


  extractFileName( fileUrl: string ): string {
    return fileUrl.split( '/' ).pop() || '';
  }

  private buildCompanyBlobUrl( companyId: string, fileName: string ): string {
    const base = environment.blobBaseUrl.replace( /\/+$/, '' );
    return `${base}/company-profiles/${companyId}/${fileName}`;
  }

  appendSasTokenToProfileImageUrl(
    imageUrl: string,
    userId: string,
    forceRefresh = false
  ): Observable<string> {
    if (!imageUrl || typeof imageUrl !== 'string') {
      return of(imageUrl as any);
    }

    const hasSas = imageUrl.includes('?sv=');
    if (hasSas && !forceRefresh) {
      return of(imageUrl);
    }

    const baseUrl = imageUrl.split('?')[0];
    const fileName = this.extractFileName(baseUrl);

    console.log("sas token forced");
    return this.sasTokenService.getSasToken(userId, fileName).pipe(
      map(sasToken => `${baseUrl}?${sasToken}`),
      catchError(error => {
        console.error(`Failed to get SAS token for user ${userId}`, error);
        return of(imageUrl);
      }),
    );
  }


}
